import { render } from "./TagSelect.vue?vue&type=template&id=70455db2"
import script from "./TagSelect.vue?vue&type=script&lang=ts"
export * from "./TagSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script